import { IPendencySimulation } from 'modules/customer/domain/entities';

export interface IVectisPendencySimulation {
  valorParcela: number;
  numeroParcelas: number;
  descricaoParcelamento: string;
}

export class PendencySimulation implements IPendencySimulation {
  public number: IPendencySimulation['number'];
  public value: IPendencySimulation['value'];
  public description: IPendencySimulation['description'];

  constructor({
    descricaoParcelamento,
    numeroParcelas,
    valorParcela,
  }: IVectisPendencySimulation) {
    this.number = numeroParcelas;
    this.value = valorParcela;
    this.description = descricaoParcelamento;
  }
}
